import { render, staticRenderFns } from "./eightPage.vue?vue&type=template&id=e63a68b4&"
import script from "./eightPage.vue?vue&type=script&lang=js&"
export * from "./eightPage.vue?vue&type=script&lang=js&"
import style0 from "./eightPage.vue?vue&type=style&index=0&id=e63a68b4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports